
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Impactfocus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Portfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impactfocus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cntrycode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"langcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bmnbr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asofdatestd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcnamestd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elemtype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectorname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectornamestd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brkdwntype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brkdwnpct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brkdwnpctstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bmbrkdwnpct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bmbrkdwnpctstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectorlevelnbr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectorlevelname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolluplevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primflag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcbasisstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcbasislocal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocheadingstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocheadinglocal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocflag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasderivatives"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"equal100"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hassector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentsectorname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brkdwnpctlong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brkdwnpctshort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bmname"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":915}};
    doc.loc.source = {"body":"query Impactfocus(\n  $fundid: String!\n  $countrycode: String!\n  $languagecode: String!\n) {\n  Portfolio(\n    fundid: $fundid\n    countrycode: $countrycode\n    languagecode: $languagecode\n  ) {\n    portfolio {\n      impactfocus {\n        fundid\n        cntrycode\n        langcode\n        bmnbr\n        asofdate\n        asofdatestd\n        calcname\n        calcnamestd\n        elemtype\n        sectorname\n        sectornamestd\n        brkdwntype\n        brkdwnpct\n        brkdwnpctstd\n        bmbrkdwnpct\n        bmbrkdwnpctstd\n        sectorlevelnbr\n        sectorlevelname\n        rolluplevel\n        rank\n        frequency\n        primflag\n        calcbasisstd\n        calcbasislocal\n        allocheadingstd\n        allocheadinglocal\n        allocflag\n        hasderivatives\n        equal100\n        hassector\n        parentsectorname\n        brkdwnpctlong\n        brkdwnpctshort\n        bmname\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Impactfocus"] = oneQuery(doc, "Impactfocus");
        
